<template>
	<CCard>
		<CCardHeader> Expéditeur </CCardHeader>
		<CCardBody>
			<CRow>
				<CCol col="12">
					<GTreeView
						placeholder="Rechercher une adresse d'expédition"
						:multiple="false"
						v-on:update:selected="data => $emit('update:addressId', data)"
						:load-options="loadOptions"
						:default-options="true"
						:async="true" />
				</CCol>
			</CRow>

			<hr />

			<form
				ref="mainForm"
				:action="addressId ? addressId : '/api/addresses'"
				:axiosMethod="addressId ? 'patch' : 'post'">
				<CInput name="type" value="sender" hidden />
				<CInput name="owner" :value="this.customerId" hidden />

				<CRow>
					<CCol col="6">
						<CInput v-model="customerAddress.lastName" name="lastName" label="Nom" />
					</CCol>
					<CCol col="6">
						<CInput v-model="customerAddress.firstName" name="firstName" label="Prénom" />
					</CCol>
					<CCol col="12">
						<CInput
							v-model="customerAddress.companyName"
							name="companyName"
							label="Dénomination sociale" />
					</CCol>

					<CCol col="12">
						<hr />
					</CCol>

					<CCol col="12">
						<div class="form-group">
							<label>Prédiction d'adresse</label>
							<GTreeView
								placeholder="Adresse"
								:multiple="false"
								v-on:update:selected="onSearchAddressSelection"
								:load-options="searchAddress"
								:async="true" />
						</div>
					</CCol>

					<CCol col="12">
						<hr />
					</CCol>

					<CCol col="12">
						<CInput v-model="customerAddress.address" name="address" label="Adresse" />
					</CCol>
					<CCol col="12">
						<CInput
							v-model="customerAddress.address2"
							name="address2"
							label="Complément d'adresse" />
					</CCol>

					<CCol col="4">
						<CInput v-model="customerAddress.postalCode" name="postalCode" label="Code postal" />
					</CCol>

					<CCol col="4">
						<CInput v-model="customerAddress.city" name="city" label="Ville" />
					</CCol>

					<CCol col="4">
						<div class="form-group">
							<CInput label="Pays" value="Réunion" disabled />
							<CInput name="country" :value="customerAddress.country" hidden />
							<!--              <GTreeView-->
							<!--                input-name="country"-->
							<!--                fetch-url="/api/countries?itemsPerPage=246"-->
							<!--                :multiple="false"-->
							<!--                placeholder="Choisissez un pays..."-->
							<!--                :value="customerAddress.country"-->
							<!--              />-->
						</div>
					</CCol>

					<CCol col="6">
						<GInputPhoneNumber
							class="phone-input-container"
							inputName="phone"
							label="Téléphone"
							:value="customerAddress.phone" />
					</CCol>
				</CRow>

				<hr />

				<CRow class="mt-3">
					<CCol>
						<GLoadingButton
							color="primary"
							class="d-inline-block"
							label="Sauvegarder"
							:loading="loading"
							v-on:click="onSubmit" />
					</CCol>
				</CRow>
			</form>
		</CCardBody>
	</CCard>
</template>

<script>
	import GLoadingButton from '../../../../../components/ghostlexly-components/GLoadingButton';
	import GInputPhoneNumber from '../../../../../components/ghostlexly-components/GInputs/GInputPhoneNumber';
	import GTreeView from '../../../../../components/ghostlexly-components/GTreeView';

	export default {
		name: 'sender-address',
		components: { GLoadingButton, GInputPhoneNumber, GTreeView },
		props: {
			addressId: String,
			customerId: String,
		},
		data() {
			return {
				customerAddress: {
					firstName: null,
					lastName: null,
					phone: null,
					address: null,
					address2: null,
					postalCode: null,
					city: null,
					country: '/api/countries/RE',
				},
				loading: false,
			};
		},

		watch: {
			customerAddress(newVal) {
				this.$emit('update:addressData', newVal);
			},

			addressId(newVal) {
				this.$axios.get(newVal).then(res => {
					this.customerAddress = res.data;
				});
			},
		},

		mounted() {
			if (this.addressId) {
				this.$axios.get(this.addressId).then(res => {
					this.customerAddress = res.data;
				});
			}
		},

		methods: {
			onSubmit() {
				this.loading = true;
				this.$formDataToApi.sendForm(this.$refs.mainForm).then(res => {
					this.loading = false;

					if (res.status === 200 || res.status === 201) {
						// set this address on the cart
						this.customerAddress = res.data;
						this.$emit('update:addressId', res.data['@id']);
						this.$toast.success('Sauvegardé avec succès');
					}
				});
			},

			loadOptions({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('search_autocomplete', searchQuery);
					params.append('type', 'sender');
					params.append('owner', this.customerId);

					this.$axios.get(`/api/addresses?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let label = `${item.lastName} ${item.firstName} - ${item.postalCode} ${item.city}`;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						callback(null, options);
					});
				}
			},

			searchAddress({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('query', searchQuery);

					this.$google.findPlacesFromQuery(searchQuery, ['re']).then(res => {
						const options = res.map(item => {
							return {
								'@id': item.place_id,
								name: item.description,
							};
						});

						callback(null, options);
					});
				}
			},

			onSearchAddressSelection(item) {
				this.$google.findByPlaceId(item).then(res => {
					this.customerAddress.address =
						this.$google.findAddressComponent(res, 'street_number').long_name +
						' ' +
						this.$google.findAddressComponent(res, 'route').long_name;

					this.customerAddress.city = this.$google.findAddressComponent(res, 'locality').long_name;
					//this.customerAddress.country = `/api/countries/${this.$google.findAddressComponent(res, "country").short_name}`;

					this.customerAddress.postalCode = this.$google.findAddressComponent(
						res,
						'postal_code'
					).long_name;
				});
			},
		},
	};
</script>
